module.exports = __webpack_public_path__ + "img/sodam_img02.329de5fc.jpg";